import { render, staticRenderFns } from "./Locales.vue?vue&type=template&id=1494d9e2"
import script from "./Locales.vue?vue&type=script&lang=js"
export * from "./Locales.vue?vue&type=script&lang=js"
import style0 from "./Locales.vue?vue&type=style&index=0&id=1494d9e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports